import { materials as MaterialsService } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';
import getCourseMaterials from './getCourseMaterials';

export const moveMaterialStart = () => ({
  type: coursesTypes.UPDATE_MATERIAL_START,
});

export const moveMaterialEnd = () => ({
  type: coursesTypes.UPDATE_MATERIAL_END,
});

export default ({ courseId, materialId, data, callback }) =>
  async dispatch => {
    try {
      dispatch(moveMaterialStart());
      await MaterialsService.moveMaterial({ materialId, data });
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(moveMaterialEnd());
      dispatch(getCourseMaterials(courseId));
    }
  };
